<template>
  <div class="feedbackForm">
    <div class="feedbackFormItem">
      <label for="">{{ $t('report.label1') }}</label>
      <el-select
v-model="form.type" :placeholder="$t('report.placeholder1')" size="large"
        popper-class="feedbackFormSelect" :popper-options="{ 'show-arrow': false }" style="width: 100%;"
        @change="handleSelectChange">
        <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value" class="el-op-item"/>
      </el-select>
    </div>
    <div class="feedbackFormItem bot">
      <label v-if="form.type != typeList[typeList.length - 1].value" for="">{{ $t('report.label2') }}</label>
      <label v-else for="">{{ $t('report.label2Required') }}</label>

      <el-input
v-model="form.content" style="width: 100%; height: 192px" type="textarea" resize="none"
        :placeholder="$t('report.placeholder2')" />
    </div>
    <div class="feedbackFormGap"/>
    <div class="feedbackFormAction">
      <el-button class="action-btn" :class="{ isCanClick: !isDisabled }" :disabled="isDisabled" @click="handleReport">
        {{ $t('report.submit') }}
      </el-button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({ taskId: { type:Number, default: 0 } });

const { t } = useI18n();
const { $showToast, $showErrorToast } = useNuxtApp();

const isDisabled = computed(() => {
  if (!form.type && form.type != 'other') {
    return true;
  }
  if (!form.content && form.type == 'other') {
    return true;
  }
  return false;
});

const typeList = [
  {
    label: t('report.reason1'),
    value: '1',
    required: false,
  },
  {
    label: t('report.reason2'),
    value: '2',
    required: false,
  },
  {
    label: t('report.reason3'),
    value: '3',
    required: false,
  },
  {
    label: t('report.reason4'),
    value: '4',
    required: false,
  },
  {
    label: t('report.reason5'),
    value: 'other',
    required: true,
  },
];

const form = reactive({
  type: '',
  content: '',
});

const emit = defineEmits(['close']);
const handleReport = async () => {
  try {
    const obj = {
      ...form,
      type: form.type,
      taskId: props.taskId,
    };
    const data = await useReportPic(obj);
    if (data.code === 200) {
      form.type = '';
      form.content = '';
      $showToast(t('report.toastSuccess'));
    } else {
      $showErrorToast(t('report.toastFailed'));
    }
  } catch (error) {
    console.log('ReportAction: ', error);
  } finally {
    handleClose();
  }
};
const handleClose = () => {
  emit('close');
};
</script>
<style lang="scss" scoped>
@media (min-width: 1000px) {
  .feedbackForm {
    // width: 560px;
    width: 100%;
    min-width: 810px;
    // padding: 25px 70px 0px 70px;
    padding: 25px 0 0;

    .feedbackFormAction {
      // margin-top: 30px;
      padding-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #eff2fc;

      .action-btn {
        width: 240px;
        height: 48px;
        background: #98A9FF;
        border-radius: 10px 10px 10px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        &.isCanClick {
          background: #1339f7;
        }
        >span {
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
          line-height: 20px;
        }
      }

      :deep() .el-button {
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
        line-height: 20px;
      }
    }

    .feedbackFormItem {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding: 0 70px;
      &.bot {
        margin-top: 11px;
      }

      >label {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        padding: 15px 0px;
      }

      :deep() .el-textarea__inner {
        height: 100% !important;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        // border: 1px solid #d8dadc;
        padding: 17px 16px 13px 16px;
        color: rgba(0,0,0,0.5);
      }
    }

    .feedbackFormGap {
      height: 71px;
      // padding-bottom: 71px;
    }
  }
}

@media (max-width: 999px) {
  .feedbackForm {
    // width: 560px;
    width: 100%;
    max-width: 810px;
    padding: 13px 0 0;

    .feedbackFormAction {
      // margin-top: 30px;
      padding-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      // border-top: 1px solid #eff2fc;

      .action-btn {
        width: 200px;
        height: 44px;
        background: #98A9FF;
        border-radius: 10px 10px 10px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 14px !important;
        color: #FFFFFF;
        line-height: 14px;
        border: none;
        &.isCanClick {
          background: #1339f7;
        }

        >span {

        }
      }

      :deep() .el-button {
        font-weight: 500;
        font-size: 14px !important;
        color: #FFFFFF;
        line-height: 14px;
      }
    }

    .feedbackFormItem {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      border: 10px;
      overflow: hidden;
      padding: 0 16px;
      &.bot {
        margin-top: 3px;
      }

      >label {
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        line-height: 18px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        padding: 15px 0px;
      }

      :deep() .el-textarea__inner {
        height: 100% !important;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #d8dadc;
        padding: 17px 16px 13px 16px;
        color: rgba(0,0,0,0.5);
        box-shadow: none;
      }
    }

    .feedbackFormGap {
      // height: 71px;
      // padding-bottom: 71px;
    }
  }
}

@media (max-width: 767px) {
  .feedbackForm {
    // width: 560px;
    width: 100%;
    max-width: 810px;
    padding: 13px 0 0;

    .feedbackFormAction {
      // margin-top: 30px;
      padding-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      // border-top: 1px solid #eff2fc;

      .action-btn {
        width: 200px;
        height: 44px;
        background: #98A9FF;
        border-radius: 10px 10px 10px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 14px !important;
        color: #FFFFFF;
        line-height: 14px;
        border: none;
        &.isCanClick {
          background: #1339f7;
        }

        >span {

        }
      }

      :deep() .el-button {
        font-weight: 500;
        font-size: 14px !important;
        color: #FFFFFF;
        line-height: 14px;
      }
    }

    .feedbackFormItem {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      border: 10px;
      overflow: hidden;
      padding: 0 16px;
      &.bot {
        margin-top: 3px;
      }

      >label {
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        line-height: 18px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        padding: 15px 0px;
      }

      :deep() .el-textarea__inner {
        height: 100% !important;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #d8dadc;
        padding: 17px 16px 13px 16px;
        color: rgba(0,0,0,0.5);
        box-shadow: none;
      }
    }

    .feedbackFormGap {
      // height: 71px;
      // padding-bottom: 71px;
    }
  }
}
</style>

<style lang="scss">
.feedbackForm {
  .el-select--large .el-select__wrapper {
    border-radius: 10px !important;
    height: 52px !important;
  }

  .el-textarea__inner {
    border-radius: 10px !important;
    color: rgba(0,0,0,0.5);
  }

  .el-select__wrapper.is-focused {
    box-shadow: 0 0 0 1px #1339F7 inset !important;
  }

  .el-textarea__inner:focus {
    box-shadow: 0 0 0 1px #1339F7 inset !important;
  }
}


.feedbackFormSelect {
  border-radius: 10px;
  overflow: hidden;

  .el-popper__arrow {
    display: none !important;
  }


  // .el-select__wrapper.is-focused
  .el-select-dropdown__list {
    border: none;
    background-color: rgba(1, 28, 82, 0.8);
    padding: 0px !important;
  }

  /* 拉框选中 */
  .el-select-dropdown__item {
    font-weight: 400;
    font-size: 14px;
    color: #636C86 !important;
    line-height: 42px;
    height: 42px;
    background: #FFFFFF;
    border-radius: 0px 0px 0px 0px;
    border-bottom: 1px solid #EFF2FC;
  }

  /* 鼠标经过下拉框 */
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background: #EFF2FC;
    color: #1339f7 !important;
  }
}

.el-op-item {
  font-family:
      SFPro,
      PingFang SC,
      Hiragino Sans GB,
      Microsoft YaHei,
      Arial,
      sans-serif;
}

.feedbackFormItem .el-select__caret {
    width: 10px;
    height: 5px;
    color: #0c062c;
    background: url(../../assets/images/vector@2x.webp) no-repeat;
    background-position: center center;
    background-size: 100% 100%;

    svg {
        display: none;
    }
}
</style>
